document.addEventListener('turbo:load', function() {
    const navbarSelect = document.getElementById('opportunity-clients-tabs');

    if (navbarSelect) {
        navbarSelect.addEventListener('change', function (){
            window.location.replace(this.value);
        });
    }
})
